import src from "IMAGE";
export default { src, width: 1501, height: 530, blurWidth: 0, blurHeight: 0};
